import InfoPageCloseButton from './info-page-close-button';
export default InfoPageCloseButton;
